/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
 */
import mergeProps from "@/router/utils/mergeProps";


let TraumaWorkflowSessionView = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/modules/coach/Resources/Workflows/TraumaWorkflowSessionView')

export default [

	{
		path: '/app/workflows/:workflowId/session/:clientId',
		name: 'TraumaWorkflowSession',
		component: TraumaWorkflowSessionView,
		props: mergeProps,
	},

]

